import { getKamProfilePicApi } from "../AccountManagement/Services/OrgRepo";
import { GENESIS_PATH } from "./config";
// export const GENESIS_PATH =
//   window.location.protocol + "//" + window.location.hostname + "/genesis";

export const backendURL =
    window.location.protocol + "//" + window.location.hostname;
export const generatProfilePicUrl = (
    id: string,
    url: string,
    field: string
) => {
    const imgUrl = GENESIS_PATH + url;

    //const imgUrl = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/All_Employee_Databases/${id}/${field}/image-download/fAFKA51OntpF3zqdf09twnhd2kVuYWXsBFdqrka6SNGJW6OP25QBJBkgYxqpD97jHvxsdZpHO6EsCq3hPfWKAKBr7pys8Tss4QWj?filepath=${url}`;
    if (url) return imgUrl;
    return null;
};
export const generatPartDrawingUrl = (id: string, url: string) => {
    //  const imgUrl = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Company_RFQ_Part_Wise_Report/${id}/Upload_Drawing/download/mywywu0jPJfUekJzskVZdS0ae4u9BfG6FSwETYP8g6v99hYjTuxAv3epaSYK1THDhf7f9AYx3GBTTHfCaPmOmhEZrFJOjfdwVmEv?filepath=${url}`;
    // if (url) return imgUrl;
    const drawingUrl = GENESIS_PATH + url;
    // const precesionXPath = `https://creatorapp.zohopublic.in//file/arun.ramu_machinemaze/precisionx/Company_RFQ_Part_Wise_Report/${id}/Upload_Drawing/download/Nkb3W898dEgXPqJxSH2J4y2euwX7yqXMtZnrjN6PtRYm4SZSZjjny2P7ktS3P6hbgGewbeee3TWxsKAvvZzANTQJRT60CNQ0X5bV?filepath=${url}`;
    if (url) return drawingUrl;
    return null;
};
export const generatStepFileUrl = (id: string, url: string) => {
    // const precesionXPath = `https://creatorapp.zohopublic.in//file/arun.ramu_machinemaze/precisionx/Company_RFQ_Part_Wise_Report/${id}/Upload_Drawing/download/Nkb3W898dEgXPqJxSH2J4y2euwX7yqXMtZnrjN6PtRYm4SZSZjjny2P7ktS3P6hbgGewbeee3TWxsKAvvZzANTQJRT60CNQ0X5bV?filepath=${url}`;
    // if (url) return precesionXPath;
    const imgUrl = GENESIS_PATH + url;
    // const imgUrl = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Company_RFQ_Part_Wise_Report/${id}/Upload_Step_File/download/mywywu0jPJfUekJzskVZdS0ae4u9BfG6FSwETYP8g6v99hYjTuxAv3epaSYK1THDhf7f9AYx3GBTTHfCaPmOmhEZrFJOjfdwVmEv?filepath=${url}`;
    if (url) return imgUrl;
    return null;
};
// export const generaQuoteAttachmentUrl = (id: string, url: string) => {
//   // const precesionXPath = `https://creatorapp.zohopublic.in//file/arun.ramu_machinemaze/precisionx/Partner_Quotation_Report/${id}/Quote_Attachment/download/ZECMyzxSrnyahgRvrHEhJ01xpwOYxYMKFVvn4K0FAv6eKNEnp21xPEDbR6hhO5kFsufdpxqW9jFpYp7273G1DjJPsAhmTCsT5W9u?filepath=${url}`;
//   // if (url) return precesionXPath;
//   const imgUrl = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Partner_Quotation_Report/${id}/Quote_Attachment/download/rCh9qqPPEJF8PTSGSwNC0XNBTfuAgNuNqTWYg9erDKEwr9tnyeWwDpy5Orn7SAvN8842j389CfQjOSjO8Kd2Haw5GKJ3nsxbVKNW?filepath=${url}`;
//   if (url) return imgUrl;
//   return null;
// };

export const QuoteAttachmentUrl = (url: string) => {
    const QuoteAttachment = GENESIS_PATH + url;
    if (url) return QuoteAttachment;
    return null;
};

// export const mmRfqAttachmentUploadDrawing = (id: string, url: string) => {
//   const DrawingFile = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Internal_RFQ_Part_Wise_Report/${id}/Upload_Drawing/download/yp4G79ywPnUMPHSEt8At7FfWPQGS2HEYvmyhREEtOBG6Mxnjn2QWUXx4NN7y2AEOvPHqwnFtBx7bUrZHfffVjTrNhgQj5YqbxEhs?filepath=${url}`;
//   if (url) return DrawingFile;
//   // const precesionXPath = `https://creatorapp.zohopublic.in//file/arun.ramu_machinemaze/precisionx/Internal_RFQ_Part_Wise_Report/${id}/Upload_Drawing/download/tyeQaJDqJhCQuOKVHhMk71Yuf73qEAW6qrR1MqR9JPP8sjSM5hNz1PH1e0vunYTwwHPjFqAdagwSkhOUtMdzFXmuF5zwBz53VwBs?filepath=${url}`;
//   // if (url) return precesionXPath;
//   return null;
// };

export const mmRfqAttachmentUploadDrawingFile = (url: string) => {
    const DrawingFileAttachment = GENESIS_PATH + url;
    if (url) return DrawingFileAttachment;
    return null;
};

// Proposal Download URL
export const proposalDownloadURL = (url: string) => {
    const proposalAttachment = GENESIS_PATH + url;
    if (url) return proposalAttachment;
    return null;
};

// export const mmRfqUploadTechDrawing = (id: string, url: string) => {
//   const DrawingTechFile = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Internal_RFQ_Form_Report/${id}/Upload_Technical_Details/download/A5Yz8WXfyKxpsGF0hgqs0rhgONBr1TVFBDVEr6GEJ6tKVg8UYzvhZHO84wRX5tmCHRXzHTVqv8pffJv6YwEOxZkQRmsJ4HOh0d2X?filepath=${url}`;
//   if (url) return DrawingTechFile;
//   // const precesionXPath = `https://creatorapp.zohopublic.in//file/arun.ramu_machinemaze/precisionx/Internal_RFQ_Form_Report/${id}/Upload_Technical_Details/download/RMpY82ka202OkteuqAuMYSTCPY8wpkRWStPHvrVhz6rT5sBFrDerGPbZurQV5MZTdFUvxH49M3uEVZzwfmBP5mBbBhW9p5ZpD8Xq?filepath=${url}`;
//   // if (url) return precesionXPath;
//   return null;
// };

export const mmRfqUploadTechDetailsFile = (url: string) => {
    const mmRfqUploadTechDetailsFile = GENESIS_PATH + url;
    if (url) return mmRfqUploadTechDetailsFile;
    return null;
};

export const generateCompanyLogo = (id: string, url: string) => {
    const companyLogoFile = GENESIS_PATH + url;
    // const companyLogoFile = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Company_Onboarding_Report/${id}/Company_Logo/image-download/72FJT6za4qHda5stCf51TAJQsvgYPQJZDY8ePsRNES3Raktv5vvrbnQngCOXNjfn5Fj0YaYSpZyzsJVxa85yQBjk0abNeRyP7fvJ?filepath=${url}`;
    if (url) return companyLogoFile;
    return null;
};
export const generateOrganisationLogo = (id: string, url: string) => {
    const organisationLogo = GENESIS_PATH + url;
    // const organisationLogo = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Organisation_Onboarding_Report/${id}/Upload_LOGO/image-download/r2QbqB8aOnDng5yR693qTBy60aEQXVbAjWvdFEuC0M0CJvXvv4hpZ3fVZ6UPrfRMOQEmXKkx9fnBFfvxeZmMJQSxnps1mt324E0H?filepath=${url}`;
    if (url) return organisationLogo;
    return null;
};

// export const generatePartnerRegistraionLogo = (
//   id: string,
//   url: string,
//   field?: string
// ) => {
//   const partnerRegistrationLogo = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Partner_Registration_Details/${id}/Upload_your_Company_Logo/image-download/ywzxePhUReEzytzNjjC5Sjpvk9mxE94J9HNH7TnWh6ZXxkKvTyUPVBSRMDpMVUBWtYbg82WGEeEyEDTTkQJnvY7BWrVf9VuN3s5a?filepath=${url}`;
//   if (url) return partnerRegistrationLogo;
//   // const byDefaultfield = field ? field : "Upload_your_Company_Logo";
//   // const precesionXPath = `https://creatorapp.zohopublic.in//file/arun.ramu_machinemaze/precisionx/Partner_Registration_Details/${id}/${byDefaultfield}/image-download/QbTBWNWZV81XvvYn6CfOgMRbxvw2ZCvghn5OJm9uqRSJmzDKte2pRfxyh4Tfe45yTCaeqsRS3pj5q7jQ30k3upUYbHVOZXarnu5M?filepath=${url}`;
//   // if (url) return precesionXPath;
//   return null;
// };

export const generatePartnerRegistrationFile = (url: string) => {
    const partnerFile = GENESIS_PATH + url;
    if (url) return partnerFile;
    return null;
};

export const getFile = (url: string) => {
    const File = GENESIS_PATH + url;
    if (url) return File;
    return null;
};

//kam profile
export const getProfilePic = async (KAMId) => {
    try {
        const data = await getKamProfilePicApi(KAMId);
        if (data?.status) {
            const img = generatProfilePicUrl(
                KAMId,
                data?.data,
                "Profile_Picture"
            );
            return img;
        }
        return null;
    } catch (err) {
        return null;
    }
};

const userEmail = localStorage.getItem("email");
const userdetails = localStorage.getItem("manager_details");
const parsedDetails =
    userdetails && userdetails != "undefined"
        ? JSON.parse(userdetails).manager_details
        : null;

export const LoggedInEmail = userEmail;
export const LoggedInUserRole = parsedDetails?.role;
export const LoggedInUserDepartment = parsedDetails?.department;
export const LoggedInUserID = parsedDetails?.userID;
export const LoggedInName = parsedDetails?.name;
export const LoggedGroup = parsedDetails?.group;
export const getLoggedInUserEmail = () => {
    const userdetails = localStorage.getItem("email");
    return userdetails;
};
export const getLoggedInEmail = () => getLoggedInUserEmail();
export const getLoggedInUserDetails = () => {
    const userdetails = localStorage.getItem("manager_details");
    return userdetails && userdetails != "undefined"
        ? JSON.parse(userdetails).manager_details
        : null;
};

export const getLoggedInUserRole = () => getLoggedInUserDetails()?.role;
export const getLoggedInUserDepartment = () =>
    getLoggedInUserDetails()?.department;
export const getLoggedInUserGroup = () => getLoggedInUserDetails()?.group;
export const getLoggedInUserID = () => getLoggedInUserDetails()?.userID;
export const getLoggedInName = () => getLoggedInUserDetails()?.name;
export const getLoggedInProfilePic = () =>
    getLoggedInUserDetails()?.User_profile_pic;

export const isAdmin = () => getLoggedInUserRole() === "Administrator";

export const isSourcingManager = () =>
    getLoggedInUserDepartment() === "Sourcing" &&
    getLoggedInUserRole()?.includes("Level 1");

export const isSourcingManagerHead = () =>
    getLoggedInUserDepartment() === "Sourcing" &&
    getLoggedInUserRole()?.includes("Level 2");

export const isAccountManager = () =>
    getLoggedInUserDepartment() === "Account Management" &&
    getLoggedInUserRole()?.includes("Level 1");

export const isAccountManagerHead = () =>
    getLoggedInUserDepartment() === "Account Management" &&
    getLoggedInUserRole()?.includes("Level 2");

export const isQualityManager = () =>
    getLoggedInUserDepartment() === "Quality Control" &&
    getLoggedInUserRole()?.includes("Level 1");

export const isQualityManagerHead = () =>
    getLoggedInUserDepartment() === "Quality Control" &&
    getLoggedInUserRole()?.includes("Level 2");

export const isProductionManager = () =>
    getLoggedInUserDepartment() === "Production" &&
    getLoggedInUserRole()?.includes("Level 1");

export const isProductionManagerHead = () =>
    getLoggedInUserDepartment() === "Production" &&
    getLoggedInUserRole()?.includes("Level 2");

export const isNPD = () =>
    getLoggedInUserDepartment() === "NPD" &&
    getLoggedInUserRole()?.includes("Level 1");

export const isNPDHead = () =>
    getLoggedInUserDepartment() === "NPD" &&
    getLoggedInUserRole()?.includes("Level 2");

export const isManagement = () => getLoggedInUserDepartment() === "Management";
// &&
//   getLoggedInUserRole()?.includes("Level 3 Manager");
// ✅ Updated Exports for Dynamic Values
export const admin = () => isAdmin();
export const sourcingManager = () => isSourcingManager();
export const sourcingManagerHead = () => isSourcingManagerHead();
export const accountManager = () => isAccountManager();
export const accountManagerHead = () => isAccountManagerHead();
export const qualityManager = () => isQualityManager();
export const qualityManagerHead = () => isQualityManagerHead();
export const productionManager = () => isProductionManager();
export const productionManagerHead = () => isProductionManagerHead();
export const NPDManager = () => isNPD();
export const NPDManagerHead = () => isNPDHead();
export const Management = () => isManagement();


export const formatCurrencyValue = (value: number | string | undefined | null, currency: string = "INR") => {
  return value !== undefined && value !== null
    ? new Intl.NumberFormat(
        currency === "INR" ? "en-IN" : "en-US",
      ).format(Number(value))
    : "";
};